/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useContext, useState, useEffect } from 'react'
import Player from './Player'
import SearchBar from "./SearchBar";
import './PlayerList.css';
import CurrentUserContext from "../../Contexts/userContexts";
import Modal from "../PopUp/Modal";
import DisplayInformation from "../PopUp/displayInformation";
import CounterComponent from "../Counter/counter"
import DisplayDisplayMessageDontAdd from "../PopUp/DisplayMessageDontAdd";

const PlayerList = () => {

    const [newTeamPlayers, setNewTeamPlayers] = useState([])
    const { singlePlayer, show, setShow, filteredPlayers, setFilteredPlayers, setselect, teamSearchValue, setTeamSearchValue, goalkeeper, setGoalkeeper, defender, setDefender, midfielder, setMidfielder, forward, setForward, setPlayerSelectState, setDisplaymessage, setDisplayMessageDontAdd } = useContext(CurrentUserContext)



    const handleSearch = (e) => {

        setNewTeamPlayers([])
        setTeamSearchValue("")
        const query = e.target.value

        const searchCards = singlePlayer.filter(player => {
            if ((player.player[0].strPlayer.toLowerCase()).includes(query.toLowerCase())) {
                return true;
            }

            if (player.player[0].strNumber !== null) {
                if ((player.player[0].strNumber).startsWith(query)) {
                    return true;
                }
            }

            if ((player.player[0].strTeam.toLowerCase()).startsWith(query.toLowerCase())) {
                return true;
            }
            if ((player.player[0].strPosition.toLowerCase().startsWith(query.toLowerCase()))) {
                return true;
            }
        });

        setFilteredPlayers(searchCards);
    }

    const toggleModal = (idPlayer) => {
        setShow(!show)
        setselect(idPlayer)
    }

    if (show) {
        document.body.classList.add('active-modal')
    } else {
        document.body.classList.remove('active-modal')
    }

    const displayPlayers = filteredPlayers.map(resultPlayer =>
        <Player {...resultPlayer.player[0]} key={resultPlayer.player[0].idPlayer} toggleModal={toggleModal} />)

    function onSelectCard(playerSelect) {
        if ((playerSelect.strPosition === 'Goalkeeper') && (goalkeeper.length === 0)) {
            setGoalkeeper([...goalkeeper, playerSelect])
            localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
            setPlayerSelectState(playerSelect.strPlayer)
            setDisplaymessage(true)
        }

        else if ((playerSelect.strPosition === "Right Back" || playerSelect.strPosition === "Full-back" || playerSelect.strPosition === "Centre Back" || playerSelect.strPosition === "Left Back" || playerSelect.strPosition === "Defender") && (defender.length <= 3)) {
            if (defender.length === 0) {
                localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                setDefender([...defender, playerSelect])
                setPlayerSelectState(playerSelect.strPlayer)
                setDisplaymessage(true)
            }
            if (defender.length > 0) {

                if (defender.includes(playerSelect) !== true) {
                    localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                    setDefender([...defender, playerSelect])
                    setPlayerSelectState(playerSelect.strPlayer)
                    setDisplaymessage(true)
                }

                else {
                    setDisplayMessageDontAdd(true)
                    setPlayerSelectState(playerSelect.strPlayer)
                }
            }
        }

        else if ((playerSelect.strPosition === "Midfielder" || playerSelect.strPosition === "Attacking Midfielder" || playerSelect.strPosition === "Centre Midfielder") && (midfielder.length <= 3)) {
            if (midfielder.length === 0) {
                localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                setMidfielder([...midfielder, playerSelect])
                setPlayerSelectState(playerSelect.strPlayer)
                setDisplaymessage(true)
            }
            else if (midfielder.length > 0) {
                if (midfielder.includes(playerSelect) !== true) {
                    localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                    setMidfielder([...midfielder, playerSelect])
                    setPlayerSelectState(playerSelect.strPlayer)
                    setDisplaymessage(true)
                }
                else {
                    setDisplayMessageDontAdd(true)
                    setPlayerSelectState(playerSelect.strPlayer)
                }
            }

        }
        else if ((playerSelect.strPosition === "Forward" || playerSelect.strPosition === "Winger" || playerSelect.strPosition === "Left Wing" || playerSelect.strPosition === "Right Wing") && (forward.length <= 1)) {
            if (forward.length === 0) {
                localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                setForward([...forward, playerSelect])
                setPlayerSelectState(playerSelect.strPlayer)
                setDisplaymessage(true)
            }
            else if (forward.length > 0) {
                if (forward.includes(playerSelect) !== true) {
                    localStorage.setItem(playerSelect.idPlayer, playerSelect.strPlayer)
                    setForward([...forward, playerSelect])
                    setPlayerSelectState(playerSelect.strPlayer)
                    setDisplaymessage(true)
                }
                else {
                    setDisplayMessageDontAdd(true)
                    setPlayerSelectState(playerSelect.strPlayer)
                }
            }

        }


        toggleModal(playerSelect.idPlayer)
    }




    const searchTeam = () => {
        if (teamSearchValue.length > 0) {
            let query

            switch (teamSearchValue) {
                case ("https://www.thesportsdb.com/images/media/team/badge/uyhbfe1612467038.png"):
                    query = "Arsenal"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/yvwvtu1448813215.png"):
                    query = "Chelsea"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/uvxuqq1448813372.png"):
                    query = "Liverpool"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/vwpvry1467462651.png"):
                    query = "Man City"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/xzqdr11517660252.png"):
                    query = "Man United"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/dfyfhl1604094109.png"):
                    query = "Tottenham"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/aofmzk1565427581.png"):
                    query = "Aston Villa"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/ywypts1448810904.png"):
                    query = "Brighton"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/sqrttx1448811003.png"):
                    query = "Burnley"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/rytxyw1448813222.png"):
                    query = "Crystal Palace"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/eqayrf1523184794.png"):
                    query = "Everton"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/grv1aw1546453779.png"):
                    query = "Brentford"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/g0eqzw1598804097.png"):
                    query = "Leeds"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/xtxwtu1448813356.png"):
                    query = "Leicester"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/lhwuiz1621593302.png"):
                    query = "Newcastle"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/795fdp1640023853.png"):
                    query = "Norwich"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/ggqtd01621593274.png"):
                    query = "Southampton"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/rsuswy1448813519.png"):
                    query = "Watford"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/yutyxs1467459956.png"):
                    query = "West Ham"
                    break;
                case ("https://www.thesportsdb.com/images/media/team/badge/u9qr031621593327.png"):
                    query = "Wolves"
                    break;

                default:
            }

            const searchCards = singlePlayer.filter(player => {
                if ((player.player[0].strTeam.toLowerCase()).includes(query.toLowerCase())) {
                    return true;
                }
            });
            setNewTeamPlayers(searchCards);
        }
    }

    const bagdeFilter = newTeamPlayers.map(resultPlayer =>
        <Player {...resultPlayer.player[0]} key={resultPlayer.player[0].idPlayer} toggleModal={toggleModal} />)

    useEffect(() => {
        setTeamSearchValue("")
        setNewTeamPlayers([])
    }, [])

    useEffect(() => {
        searchTeam()
    }, [teamSearchValue])





    return (
        <div>

            <div className="divDad">
                <div>
                    <DisplayInformation />
                </div>
                <div>
                    <DisplayDisplayMessageDontAdd />
                </div>
                <Modal onSelectCard={onSelectCard} />
                <SearchBar handleSearch={handleSearch} />
                <div className="playerDisplayBody">
                    <div className="gridBox"><CounterComponent /></div>
                    <div className="playerDisplay">{newTeamPlayers.length === 0 && displayPlayers}
                        {newTeamPlayers && bagdeFilter}</div>
                </div>
            </div>
        </div>
    )
}


export default PlayerList